/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type PaginationEntity = {
  /**
   * Total number of records in the list
   */
  totalRecords: number;
  /**
   * Total number of pages available
   */
  totalPages: number;
  /**
   * The current page number
   */
  currentPage: number;
  /**
   * The next page number, or null if there is no next page
   */
  nextPage: number | null;
  /**
   * The previous page number, or null if there is no previous page
   */
  prevPage: number | null;
};

/** @internal */
export const PaginationEntity$inboundSchema: z.ZodType<
  PaginationEntity,
  z.ZodTypeDef,
  unknown
> = z.object({
  total_records: z.number(),
  total_pages: z.number(),
  current_page: z.number(),
  next_page: z.nullable(z.number()),
  prev_page: z.nullable(z.number()),
}).transform((v) => {
  return remap$(v, {
    "total_records": "totalRecords",
    "total_pages": "totalPages",
    "current_page": "currentPage",
    "next_page": "nextPage",
    "prev_page": "prevPage",
  });
});
/** @internal */
export type PaginationEntity$Outbound = {
  total_records: number;
  total_pages: number;
  current_page: number;
  next_page: number | null;
  prev_page: number | null;
};

/** @internal */
export const PaginationEntity$outboundSchema: z.ZodType<
  PaginationEntity$Outbound,
  z.ZodTypeDef,
  PaginationEntity
> = z.object({
  totalRecords: z.number(),
  totalPages: z.number(),
  currentPage: z.number(),
  nextPage: z.nullable(z.number()),
  prevPage: z.nullable(z.number()),
}).transform((v) => {
  return remap$(v, {
    totalRecords: "total_records",
    totalPages: "total_pages",
    currentPage: "current_page",
    nextPage: "next_page",
    prevPage: "prev_page",
  });
});

export function paginationEntityToJSON(
  paginationEntity: PaginationEntity,
): string {
  return JSON.stringify(
    PaginationEntity$outboundSchema.parse(paginationEntity),
  );
}
export function paginationEntityFromJSON(
  jsonString: string,
): SafeParseResult<PaginationEntity, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PaginationEntity$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PaginationEntity' from JSON`,
  );
}
